import { Button } from '@library/components/buttons';
import { classNames } from '@library/utils';

// DO NOT USE - THIS IS A LEGACY COMPONENT
// USE ACTION BUTTON INSTEAD AND PASS THE VARIANT AS A PROP
export interface SecondaryButtonProps {
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  handleOnClick: React.MouseEventHandler<HTMLButtonElement>;
  title?: string;
  testId?: string;
}

export const SecondaryButton = ({
  className = '',
  children = undefined,
  disabled = false,
  handleOnClick,
  title = '',
  testId = 'secondary-button'
}: SecondaryButtonProps) => {
  return (
    <Button
      className={classNames(
        'bg-soFresh-120 text-soClean-100 disabled:bg-soFresh-150 disabled:text-soClean-180 flex items-center justify-center gap-2 rounded-md px-3 py-2 text-base font-medium disabled:cursor-not-allowed',
        className
      )}
      disabled={disabled}
      title={title}
      onClick={handleOnClick}
      type="button"
      data-testid={testId}
    >
      {children}
    </Button>
  );
};
